import React from 'react';
import { Switch, Route } from 'react-router-dom';
import EmailResetLink from './email-reset-link/EmailResetLink.container';
import PasswordSent from './password-sent/PasswordSent.container';
import PasswordUpdated from './password-updated/PasswordUpdated.container';
import NewPassword from './new-password/NewPassword.container';
import {
	ROUTE_FORGOT_PASSWORD_SENT,
	ROUTE_FORGOT_PASSWORD_NEW,
	ROUTE_FORGOT_PASSWORD_UPDATED,
} from '../../../constants/Routes';

export default ({ location }) => (
	<Switch location={location}>
		<Route path={ROUTE_FORGOT_PASSWORD_SENT} exact component={PasswordSent} />
		<Route path={ROUTE_FORGOT_PASSWORD_UPDATED} exact component={PasswordUpdated} />
		<Route path={ROUTE_FORGOT_PASSWORD_NEW} exact component={NewPassword} />
		<Route component={EmailResetLink} />
	</Switch>
);
